import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import OnsiteField from 'account/components/onsite_field';
import { toggleSiteNotification, updateSettings } from 'account/ducks/notification_settings';
import { atAdmin } from 'common/utils';
import partial from 'lodash/partial';

export function mapStateToProps(state, { id, notification }) {
  const { notificationSettings, user } = state;
  const profileData = atAdmin(state)? state.admin.people.currentUser : user.profile_data;
  const idNum = id * 1;
  const checked = notificationSettings.data.onsite.indexOf(idNum) !== -1;
  const clientShow = profileData.is_client && notification.user_type.indexOf('client') !== -1;
  const creativeShow = profileData.is_creative && notification.user_type.indexOf('creative') !== -1;
  const shouldShow = clientShow || creativeShow;

  return {
    checked,
    shouldShow,
  };
}

export function mapDispatchToProps(dispatch, { id }) {
  return bindActionCreators({
    onChange: partial(toggleSiteNotification, id),
    updateSettings,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OnsiteField);



// WEBPACK FOOTER //
// ./account/containers/onsite_field.js